import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoRegistroCorrispettiviIvaStep2Component } from './conservazione-carica-documento-registro-corrispettivi-iva-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-registro-corrispettivi-iva-step2', {
            url: '/conservazione-carica-registro-corrispettivi-iva',
            ncyBreadcrumb: {
                label: 'Carica Registro Corrispettivi Iva',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-registro-corrispettivi-iva-step2 flex="100"></conservazione-carica-documento-registro-corrispettivi-iva-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoRegistroCorrispettiviIvaStep2Module: string = ng
    .module('conservazione-carica-documento-registro-corrispettivi-iva-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoRegistroCorrispettiviIvaStep2', ConservazioneCaricaDocumentoRegistroCorrispettiviIvaStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-registro-corrispettivi-iva-step2/conservazione-carica-documento-registro-corrispettivi-iva-step2.module.ts